/**
 * Editor soạn bài diễn đàn (2026-10-03) — dùng lại RichMarkdownEditor của trang sửa bài học
 * (định dạng, bảng, công thức MathType, Markdown gốc, Xem trước). Nội dung vẫn lưu markdown.
 *
 * Tải LAZY: trang môn của sinh viên không phải tải Milkdown khi chưa soạn bài; không tải trước
 * MathType (chỉ tải khi bấm chèn công thức).
 */
import { LazyRichMarkdownEditor } from "@/components/RichMarkdownEditor/LazyRichMarkdownEditor";

interface Props {
  value?: string;
  onChange?: (markdown: string) => void;
  height?: number;
  placeholder?: string;
}

export function ForumEditor({ value, onChange, height = 260, placeholder }: Props) {
  return (
    <LazyRichMarkdownEditor
      value={value}
      onChange={onChange}
      height={height}
      placeholder={placeholder}
      warmUpMath={false}
    />
  );
}
